/* eslint-disable */
import { ReactElement } from "react";
import { Descriptions, Typography } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import * as React from "react";
import type { DescriptionsProps } from 'antd';
import Card from "Components/Card/Card";
import Badge from "Components/Badge/Badge";
const { Text } = Typography;

const DESCRIPTIONS_COLUMN = { xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 };

const SectionTitle = ({ children }: { children: React.ReactNode }): ReactElement => (
  <div className="ric-section-title">
    <span className="ric-section-title__icon">
      <TeamOutlined />
    </span>
    {children}
  </div>
);

export type AccountInformation = {
  accountNumber: string;
  unitAddress: string;
  property: string;
  cm: string;
  cmEmail: string;
  am: string;
  office: string;
  admin: string;
  vp: string;
  delinquencyStatus: string;
  liened: string;
  subLedgerType: string;
  communityName: string;
  unitLot: string;
  unitBlock: string;
  escrowStr: string;
  rcDate5: string;
  salutation: string;
  communityDistributionEmail: string;

  accountInfo: AccountInformation;
  isReadOnlyUser: boolean;
  query: string;
  loading: boolean;
  message: string;
  companyKey: string;
  autocompleteLoading: boolean;
  autocompleteOpen: boolean;
  autocompleteOptions: any[];
  properties: any[];
  activeTab: string;
  propertyName: string;
  propertyNameInTypeahead: string;
  selectedProperty: any | null;
  propertyInputText: string;
  isActiveAdvancedSearch: boolean;
  isAccessToProperty: boolean;
  ownerFilters: any;
  isLoadLoader: boolean;
  isLoadLoaderZEGO: boolean;
  contactInfo: any | null;
  hideButtons: boolean;
  hideNotes: boolean;
  isDisabledAccountSearch: boolean;
  isDisabledNameSearch: boolean;
  isDisabledAddressSearch: boolean;
  isDisabledETrakContactIDSearch: boolean;
  isOpenDialog: boolean;
  isOpenLoad: boolean;
  isOpenSnack: boolean;
  isAuth: boolean;
  isLoadEnd: boolean;
  dialogFirstName: string | null;
  dialogLastName: string | null;
  dialogDateRecived: Date | null;
  dialogExpirationDate: Date | null;
  dialogDOB: Date | null;
  dialogEmail: string | null;
  dialogPhone: string | null;
  rentersAccNumbers: any[];
  activeRenters: any[];
  noActiveRenters: any[];
  mainAccNumb: string;
  futuresAccNumbers: any[];
  activeFutures: any[];
  noActiveFutures: any[];
  isMainAcc: boolean;
  isAddRenter: number;
  textAccountNumber: string;
  isOpenModalDelete: boolean;
  isLoaderLoad: boolean;
  isETrakType: boolean;
};

const styles = {
  accountInfoCard: {
    flex: "1 1 260px",
    textAlign: "start" as const,
    alignSelf: "stretch",
    padding: "5px",
    margin: "5px",
    borderRadius: "5px",
  },
  accountInfoField: {
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as const,
    WebkitLineClamp: "1",
    overflow: "hidden",
    marginBottom: "2px",
  },
  accountInfoOverflowField: {
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as const,
    WebkitLineClamp: "3",
    overflow: "hidden",
    marginBottom: "2px",
  },
  infinityLineField: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as const,
    marginBottom: "2px",
    minWidth: 0,
    overflowWrap: "anywhere" as const,
  },
};
const fieldLabelStyle = { color: "#6b7280", fontWeight: 700 as const };
const fieldValueStyle = { color: "#111827", fontWeight: 600 as const };

export const InlineField = ({
  label,
  value,
}: {
  label: string | ReactElement;
  value: string | ReactElement;
}) => (
  <div style={styles.accountInfoField}>
    <span style={fieldLabelStyle}>{label} </span>
    <span style={fieldValueStyle}>{value}</span>
  </div>
);
export const ThreeLineField = ({
  label,
  value,
}: {
  label: string | ReactElement;
  value: string | ReactElement;
}) => (
  <div style={styles.accountInfoOverflowField}>
    <span style={fieldLabelStyle}>{label}</span>
    <span style={fieldValueStyle}>{value}</span>
  </div>
);
export const InfinityLineField = ({
  label,
  value,
}: {
  label: string | ReactElement;
  value: string | ReactElement;
}) => (
  <div style={styles.infinityLineField}>
    <span style={fieldLabelStyle}>{label} </span>
    <span style={fieldValueStyle}>{value}</span>
  </div>
);
const AccountInfoCard = (props: {
  accountInfo: AccountInformation;
}): ReactElement => {
  const { accountInfo } = props;

  const delinquency = [
    accountInfo.delinquencyStatus?.toUpperCase(),
    accountInfo.liened?.toUpperCase(),
  ]
    .filter(Boolean)
    .join(" ");

  const dash = <span className="rg-dash">—</span>;

  const accountItems = [
    { label: "Account Number", children: accountInfo.accountNumber || dash },
    { label: "Unit Address", children: accountInfo.unitAddress || dash },
    { label: "Property", children: accountInfo.property || dash },
    {
      label: "Account Type",
      children: accountInfo.subLedgerType ? (
        <Badge text={accountInfo.subLedgerType?.toUpperCase()} variant="green" />
      ) : (
        dash
      ),
    },
    { label: "Move In Date", children: accountInfo.escrowStr || dash },
    { label: "Community", children: accountInfo.communityName || dash },
    { label: "Legal Owner Name", children: accountInfo.salutation || dash },
    { label: "Block", children: accountInfo.unitBlock || dash },
    { label: "Lot", children: accountInfo.unitLot || dash },
    {
      label: "Delinquency Status",
      children: delinquency ? (
        <span style={{ color: "#cf3d3d" }}>{delinquency}</span>
      ) : (
        dash
      ),
    },
  ];

  const managementItems = [
    { label: "Office", children: accountInfo.office || dash },
    { label: "CM", children: accountInfo.cm || dash },
    { label: "AM", children: accountInfo.am || dash },
    { label: "Admin", children: accountInfo.admin || dash },
    { label: "CM Email", children: accountInfo.cmEmail || dash },
    { label: "Regional", children: accountInfo.vp || dash },
    {
      label: "Community Distribution Email",
      children: accountInfo.communityDistributionEmail || dash,
    },
  ];

  return (
    <Card className="ric-card ric-info-card">
      <Descriptions
        title={<SectionTitle>Account Info</SectionTitle>}
        items={accountItems}
        column={DESCRIPTIONS_COLUMN}
        labelStyle={{ whiteSpace: "nowrap" }}
        contentStyle={{ wordBreak: "break-word" }}
      />
      <div className="ric-info-card__divider" />
      <Descriptions
        title={<SectionTitle>Management Team Info</SectionTitle>}
        items={managementItems}
        column={DESCRIPTIONS_COLUMN}
        labelStyle={{ whiteSpace: "nowrap" }}
        contentStyle={{ wordBreak: "break-word" }}
      />
    </Card>
  );
};

export default AccountInfoCard;
